import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, IconButton, Tooltip, Box, SelectChangeEvent, Chip, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { getDocuments, addDocuments, editDocuments, editVehicle, getDriverName, getOwnerName, addOwner, addOwnerDetails, deleteDocument, fetchVendors, addWarehouseUserMapping, getWarehouseUserMapping, deleteUserWarehousemapping, verifyOTP, deleteVehicle, activateVehicle, getWarehouseCompanyMapping, getMakeModels } from './action.ts';
import AddOwnerModal from './add-owner-modal.tsx';
import ConfirmationPopup from '../../Components/ConfirmationModal/confirmation-modal.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import UploadIcon from '@mui/icons-material/CloudUpload';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import '../../Components/Table/table-style.scss';
import DatePicker from '../../Components/DatePicker/date-picker.tsx';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import './vehicle.scss';
import ConfirmationModal from './confirmation-modal.tsx';
import OTPVerificationModal from './otp-verification-modal.tsx';
import CancelIcon from '@mui/icons-material/Cancel';
import AddNewModelModal from '../Devices/addNewModelModal.tsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface EditVehicleModalProps {
  open: boolean;
  onClose: () => void;
  vehicle: {
    id: any;
    number_plate: string;
    make_model: string;
    reg_date: string;
    owner: string;
    driver: string;
    owner_phone: any;
    driver_phone: any;
    driver_id: string;
    fuel_type: string;
    active: number;
  } | null;
  tab: any;
}
interface Warehouse {
  id: number;
  name: string;
}
interface Vendor {
  id: number;
  name: string;
}

const EditVehicleModal: React.FC<EditVehicleModalProps> = ({ open, onClose, vehicle, tab }) => {
  const [formValues, setFormValues] = useState({
    vehicle_no: '',
    model: '',
    reg_date: '',
    owner: '',
    driver: '',
    driver_phone: '',
    fuel_type: '',
    owner_phone: ''
  });
  const [initialValues, setInitialValues] = useState(formValues);
  const [selectedInsuranceDate, setSelectedInsuranceDate] = useState<string>('');
  const [selectedFitnessDate, setSelectedFitnessDate] = useState<any>('');
  const [initialInsuranceDate, setInitialInsuranceDate] = useState<any>('');
  const [initialFitnessDate, setInitialFitnessDate] = useState<any>('');
  const [getFitnessDoc, setGetFitnessDoc] = useState<string>('');
  const [getInsuranceDoc, setGetInsuranceDoc] = useState<string>('');
  const [documentList, setDocumentList] = useState<any[]>([]);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [inactiveVehicle, setInactiveVehicle] = useState(false);
  const [documentToRemove, setDocumentToRemove] = useState<string | null>(null);
  const [ownerUserName, setOwnerUserName] = useState<string>('');
  const [isAddOwnerModalOpen, setIsAddOwnerModalOpen] = useState(false);
  const [driverUserName, setDriverUserName] = useState<string>('');
  const [ownerPhoneNumber, setOwnerPhoneNumber] = useState<string>('');
  const [driverPhoneNumber, setDriverPhoneNumber] = useState<string>('');
  const [documentDeleted, setDocumentDeleted] = useState(false);
  const [ownerId, setOwnerId] = useState<string>('');
  const [driverId, setDriverId] = useState<string>('');
  const [isOwnerFocused, setIsOwnerFocused] = useState<boolean>(false);
  const [isDriverFocused, setIsDriverFocused] = useState<boolean>(false);
  const [ownerError, setOwnerError] = useState<string | null>(null);
  const [driverError, setDriverError] = useState<string | null>(null);
  const [regDateError, setRegDateError] = useState<string | null>(null);
  const [modelError, setModelError] = useState<string | null>(null);
  const [warehouseError, setWarehouseError] = useState<string | null>(null);
  const [documentLocation, setDocumentLocation] = useState<string | null>(null);
  const [documentId, setDocumentId] = useState<number | null>(null);
  const [getInsuranceDate, setGetInsuranceDate] = useState<string | null>(null);
  const [getFitnessDate, setGetFitnessDate] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [fuelType, setFuelType] = useState<{ id: string; label: string }[]>([]);
  const [fuelName, setFuelName] = useState<string>('');
  const [selectedVendor, setSelectedVendor] = useState<{ id: string; label: string }[]>([]);
  const [warehouseData, setWarehouseData] = useState<Warehouse[]>([]);
  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string; label: string }[]>([]);
  const [warehouseId, setWarehouseId] = useState<{ user_warehouse_id: string; warehouse_id: string; label: string }[]>([]);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [modelOptions, setModelOptions] = useState<{ id: string; label: string }[]>([]);
  const [isAddNewModelModalOpen, setIsAddNewModelModalOpen] = useState(false);
  const [newModelValue, setNewModelValue] = useState("");
  const storedUserDetails = localStorage.getItem("userdetails");
  const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
  const userRole = userDetails ? userDetails.role : null
  const vendorName = userDetails ? userDetails.vendor_name : null;
  const clientName = userDetails ? userDetails.client_name : null;
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState<string>('');
  const isInactiveTab = vehicle?.active === 0;
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const companiesId = userDetailsFromStorage?.companies_id || '';
  const maxDate = new Date();
  let otpVerified = '';
  let isOtpVerified = false;
  const resetErrorMessages = () => {
    setOwnerError(null);
    setDriverError(null);
    setRegDateError(null);
    setModelError(null);
    setWarehouseError(null);
    setErrorMessage(null);
    setSelectedInsuranceDate('');
    setGetFitnessDate('');
    setGetInsuranceDate('');
    setSelectedFitnessDate('');
    setSelectedWarehouse([]);
    setWarehouseData([]);
  };
  const handleClose = () => {
    resetErrorMessages();
    onClose();
  };
  const handleOwnerFocus = () => {
    setIsOwnerFocused(true);
    setOwnerUserName('');
  };
  const handleOwnerBlur = () => {
    if (ownerPhoneNumber.length === 10) {
      fetchDriverDetails(ownerPhoneNumber, 'owner');
    }
    setIsOwnerFocused(false);
  };

  const handleDriverFocus = () => {
    setIsDriverFocused(true);
  };
  const handleDriverBlur = () => {
    setIsDriverFocused(false);
  };
  const fuelTypeOptions = [
    { id: 'diesel', label: 'Diesel' },
    { id: 'EV', label: 'EV' },
    { id: 'petrol', label: 'Petrol' },
    { id: 'CNG', label: 'CNG' }
  ];

  const [selectedFiles, setSelectedFiles] = useState<{ [key: string]: File | null }>({
    registrationCertificate: null,
    pollutionCertificate: null,
    fitnessCertificate: null,
    insurance: null,
    drivers_license: null,
    aadhar: null
  });

  const [icons, setIcons] = useState<{ [key: string]: string }>({
    registrationCertificate: 'upload',
    pollutionCertificate: 'upload',
    fitnessCertificate: 'upload',
    insurance: 'upload'
  });

  const fetchDocuments = () => {
    if (vehicle?.id) {
      getDocuments(
        vehicle.id,
        (response: any) => {
          const documentDetails = response.message?.vehicle_documents || [];
          setDocumentList(documentDetails);
          const updatedDocuments = documentDetails.map((doc: any) => ({
            ...doc,
            expiry: doc.status === 'uploaded' ? doc.expiry || '' : ''
          }));
          const insuranceDoc = updatedDocuments.find((doc: any) =>
            doc.document_name.trim() === 'insurance' && doc.status === 'uploaded'
          );
          const fitnessDoc = updatedDocuments.find((doc: any) =>
            doc.document_name.trim() === 'fitness certificate' && doc.status === 'uploaded'
          );
          if (insuranceDoc) {
            setGetInsuranceDate(insuranceDoc.expiry);
            setInitialInsuranceDate(insuranceDoc.expiry);
            setGetInsuranceDoc(insuranceDoc);
          }
          if (fitnessDoc) {
            setGetFitnessDate(fitnessDoc.expiry);
            setInitialFitnessDate(fitnessDoc.expiry);
            setGetFitnessDoc(fitnessDoc);
          }
          const newIcons: { [key: string]: string } = {
            registrationcertificate: 'upload',
            pollutioncertificate: 'upload',
            fitnesscertificate: 'upload',
            insurance: 'upload'
          };
          documentDetails.forEach((doc: { status: string; document_name: string; }) => {
            if (doc.status === 'uploaded') {
              newIcons[doc.document_name.replace(' ', '')] = 'view';
            }
          });
          setIcons(newIcons);
        },
        (errMessage: any) => {
          toast.error(errMessage);
        }
      );
    }
  };

  useEffect(() => {
    if (open) {
      getMakeModels(
        (response: any) => {
          if (response.status === 200 && response.data?.vehicle_models) {
            const mappedModels = response.data.vehicle_models
              .map((model: string) => ({
                id: model,
                label: model
              }))
              .sort((a: any, b: any) => a.label.localeCompare(b.label));
            setModelOptions([
              ...mappedModels, 
              { id: 'ADD_NEW_MODEL_ACTION', label: '+ Add New Model' }
            ]);
          }
        },
        (error: any) => {
          toast.error(error?.message || "Failed to fetch vehicle models");
        }
      );
    }

    if (open && vehicle?.id) {
      fetchDocuments();
    }

    if (open && vehicle) {
      const parseDate = (dateString: string) => {
        if (!dateString) return new Date();
        if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return new Date(dateString);
        }
        const [day, month, year] = dateString.split('-');
        return new Date(`${year}-${month}-${day}`);
      };

      const formatDate = (date: Date) => {
        return !isNaN(date.getTime()) ? date.toISOString().split('T')[0] : '';
      };

      const formattedRegDate = vehicle.reg_date ? formatDate(parseDate(vehicle.reg_date)) : '';
      setFormValues({
        vehicle_no: vehicle.number_plate || '',
        model: vehicle.make_model || vehicle.make_model || '',
        reg_date: formattedRegDate || '',
        owner: vehicle.owner || vehicle.owner_name || '',
        driver: vehicle.driver || vehicle.driver_name || '',
        driver_phone: vehicle.driver_phone || '',
        fuel_type: vehicle.fuel_type || '',
        owner_phone: vehicle.owner_phone || ''
      });

      setInitialValues({
        vehicle_no: vehicle.number_plate || '',
        model: vehicle.make_model || vehicle.make_model || '',
        reg_date: formattedRegDate || '',
        owner: vehicle.owner || vehicle.owner_name || '',
        driver: vehicle.driver || vehicle.driver_name || '',
        driver_phone: vehicle.driver_phone || '',
        fuel_type: vehicle.fuel_type || '',
        owner_phone: vehicle.owner_phone || ''
      });
      
      if (vehicle?.driver_id) {
        getWarehouseUserMapping(
          vehicle?.driver_id,
          (response) => {
            const userWarehouses = response.user_warehouses.map((mapping: any) => mapping.warehouse);
            const mappingDetails = response.user_warehouses.map((mapping: any) => ({
              user_warehouse_id: mapping.id,
              warehouse_id: mapping.warehouse.id,
              warehouse_name: mapping.warehouse.name
            }));
            setWarehouseData(userWarehouses);
            const initialSelected = userWarehouses.map((wh: any) => ({
              id: wh.id.toString(),
              label: wh.name
            }));
            setSelectedWarehouse(initialSelected);
            setWarehouseId(mappingDetails);
          },
          (errorMessage) => { toast.error(errorMessage); }
        );
      }
      setOwnerUserName(vehicle.owner || vehicle.owner_name || '');
      setOwnerPhoneNumber(vehicle.owner_phone || '');
      setDriverPhoneNumber(vehicle.driver_phone || '');
      setDriverUserName(vehicle.driver || vehicle.driver_name || '');
    }
    
    if (vendorName !== '' && vehicle && open) {
      getWarehouseCompanyMapping(
        companiesId,
        (response: any) => {
          const warehouses = response.user_warehouses.map((item: any) => item.warehouse);
          setWarehouses(warehouses);
        },
        (errMessage: any) => {
          toast.error(errMessage.message);
        }
      );
    } else if (clientName !== '' && vehicle && open) {
      fetchVendors(
        (response) => setVendors(response),
        (errorMessage) => toast.error(errorMessage)
      );
    }
  }, [vehicle, open]);

  useEffect(() => {
    if (vehicle?.fuel_type) {
      const matchedOption = fuelTypeOptions.find(option => option.id === vehicle.fuel_type);
      if (matchedOption) {
        setFuelType([{ id: matchedOption.id.toString(), label: matchedOption.label }]);
      }
    }
  }, [vehicle?.fuel_type]);

  useEffect(() => {
    if (warehouseData && warehouses) {
      const matchedWarehouses = warehouses.filter(warehouse =>
        warehouseData.some(wh => wh.name === warehouse.name)
      );
      const newSelectedWarehouses = matchedWarehouses.map(warehouse => ({
        id: warehouse.id.toString(),
        label: warehouse.name
      }));

      setSelectedWarehouse(newSelectedWarehouses);
    }
  }, [warehouseData, warehouses]);

  const handleChange = (e: SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleModelChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (value === 'ADD_NEW_MODEL_ACTION') {
      setIsAddNewModelModalOpen(true);
    } else {
      setFormValues(prevValues => ({
        ...prevValues,
        model: value
      }));
      setModelError(null);
    }
  };

  const handleAddNewModelSubmit = () => {
    if (!newModelValue.trim()) {
      toast.error("Model name cannot be empty");
      return;
    }

    setModelOptions((prevOptions) => {
      const filteredOptions = prevOptions.filter(opt => opt.id !== 'ADD_NEW_MODEL_ACTION');
      const updatedModels = [
        ...filteredOptions,
        { id: newModelValue, label: newModelValue }
      ].sort((a, b) => a.label.localeCompare(b.label));
      return [
        ...updatedModels,
        { id: 'ADD_NEW_MODEL_ACTION', label: '+ Add New Model' }
      ];
    });

    setFormValues((prev) => ({ ...prev, model: newModelValue }));
    setModelError(null);

    setNewModelValue("");
    setIsAddNewModelModalOpen(false);
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    validatePhoneNumber(value, name);
    if (name === 'driver') {
      setDriverPhoneNumber(value);
      if (value.length === 0 || value.length < 10) {
        setDriverUserName('');
        setWarehouseError('')
        setDriverId('');
      }
      if (value.length === 10) {
        fetchDriverDetails(value, 'driver');
      }
    } else {
      setOwnerPhoneNumber(value);
      if (value.length === 0 || value.length < 10) {
        setOwnerUserName('');
        setOwnerId('');
      }
    }
  };

  const uploadFile = (type: string, file: File, insuranceDate: string, fitnessCerificateDate: string, action: string) => {
    let insuranceExpiryDate = '';
    let fitnessExpiryDate = '';
    if (type === 'insurance') {
      insuranceExpiryDate = insuranceDate;
    } else if (type === 'fitnesscertificate') {
      fitnessExpiryDate = fitnessCerificateDate;
    }
    if (action === 'add') {
      addDocuments(
        type === 'drivers_license' ? file : null,
        type === 'aadhar' ? file : null,
        type === 'registrationcertificate' ? file : null,
        type === 'insurance' ? file : null,
        type === 'fitnesscertificate' ? file : null,
        type === 'pollutioncertificate' ? file : null,
        vehicle?.id,
        fitnessExpiryDate,
        insuranceExpiryDate,
        (response) => {
          if (response.status === 200) {
            setSelectedFiles((prevFiles) => ({
              ...prevFiles,
              [type]: file
            }));
            setIcons((prevIcons) => ({
              ...prevIcons,
              [type]: 'view'
            }));
            toast.success("Document Uploaded Successfully");
            setErrorMessage(null);
            setDocumentLocation(response?.message?.location);
            setDocumentId(response?.message?.id)
          }
        },
        (errMessage: any) => {
          if (errMessage.status === 400) {
            let allErrorMessages: string[] = [];
            if (typeof errMessage.message === 'string') {
              allErrorMessages.push(errMessage.message);
              setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [type]: file
              }));
              setIcons((prevIcons) => ({
                ...prevIcons,
                [type]: 'view'
              }));
              toast.error(allErrorMessages.join(" "));
            }
            else if (errMessage.status = 413) {
              toast.error("Document Size is large");
            }
            else if (errMessage.message && typeof errMessage.message === 'object') {
              const errors = errMessage.message.errors || {};
              for (const [key, messages] of Object.entries(errors)) {
                if (Array.isArray(messages)) {
                  allErrorMessages.push(...messages);
                }
              }
              setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [type]: null
              }));
              setIcons((prevIcons) => ({
                ...prevIcons,
                [type]: 'upload'
              }));
              toast.error(allErrorMessages.join(" "));
            }
            if (allErrorMessages.length > 0) {
              setErrorMessage(allErrorMessages.join(" "));
            }
          }
        });
    }
    else {
      editDocuments(
        type === 'drivers_license' ? file : null,
        type === 'aadhar' ? file : null,
        type === 'registrationcertificate' ? file : null,
        type === 'insurance' ? file : null,
        type === 'fitnesscertificate' ? file : null,
        type === 'pollutioncertificate' ? file : null,
        vehicle?.id,
        fitnessExpiryDate,
        insuranceExpiryDate,
        (response) => {
          if (response.status === 200) {
            setSelectedFiles((prevFiles) => ({
              ...prevFiles,
              [type]: file
            }));
            setIcons((prevIcons) => ({
              ...prevIcons,
              [type]: 'view'
            }));
            toast.success("Document Uploaded Successfully");
            setErrorMessage(null);
          }
        },
        (errMessage: any) => {
          if (errMessage.status === 400) {
            let allErrorMessages: string[] = [];
            if (typeof errMessage.message === 'string') {
              allErrorMessages.push(errMessage.message);
              setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [type]: file
              }));
              setIcons((prevIcons) => ({
                ...prevIcons,
                [type]: 'view'
              }));
              toast.error(allErrorMessages.join(" "));
            }
            else if (errMessage.status = 413) {
              toast.error("Document Size is large");
            }
            else if (errMessage.message && typeof errMessage.message === 'object') {
              const errors = errMessage.message.errors || {};
              for (const [key, messages] of Object.entries(errors)) {
                if (Array.isArray(messages)) {
                  allErrorMessages.push(...messages);
                }
              }
              setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [type]: null
              }));
              setIcons((prevIcons) => ({
                ...prevIcons,
                [type]: 'upload'
              }));
              toast.error(allErrorMessages.join(" "));
            }
            if (allErrorMessages.length > 0) {
              setErrorMessage(allErrorMessages.join(" "));
            }
          }
        });
    }
  };

  const handleConfirmRemove = () => {
    if (vehicle?.active === 1 && !documentToRemove) {
      deleteVehicle(vehicle?.id, (response) => {
        toast.success(response.message)
        setInactiveVehicle(false);
        onClose();
      }, (errorMessage) => {
        toast.error(errorMessage.message)
      })
      setInactiveVehicle(false);
      setIsConfirmationOpen(false);
    }
    else if (vehicle?.active === 0 && !documentToRemove) {
      activateVehicle(vehicle?.id, (response) => { toast.success(response.message) }, (errorMessage) => { toast.error(errorMessage.message) })
      setInactiveVehicle(false);
      setIsConfirmationOpen(false);
      onClose();
    }
    else if (documentToRemove && vehicle?.id) {
      const document = documentList.find(doc =>
        doc.document_name.replace(' ', '').toLowerCase() === documentToRemove.toLowerCase() &&
        doc.status === 'uploaded'
      );
      if (documentId) {
        deleteDocument(
          documentId,
          vehicle?.id,
          (response) => {
            toast.success(response?.message);
            setSelectedFiles((prevFiles) => ({
              ...prevFiles,
              [documentToRemove]: null
            }));
            setIcons((prevIcons) => ({
              ...prevIcons,
              [documentToRemove]: 'upload'
            }));
            setDocumentLocation('');
            setSelectedInsuranceDate('');
            setGetInsuranceDate('');
            setSelectedFitnessDate('');
            setGetFitnessDate('');
            setErrorMessage('');
            setInitialInsuranceDate('');
            setInitialFitnessDate('');
          },
          (errorMessage) => {
            toast.error(errorMessage.data.message);
          }
        );
      }
      else {
        deleteDocument(
          document?.id,
          vehicle?.id,
          (response) => {
            toast.success(response?.message);
            setSelectedFiles((prevFiles) => ({
              ...prevFiles,
              [documentToRemove]: null
            }));
            setIcons((prevIcons) => ({
              ...prevIcons,
              [documentToRemove]: 'upload'
            }));
            setDocumentLocation('');
            setSelectedInsuranceDate('');
            setGetInsuranceDate('');
            setSelectedFitnessDate('');
            setGetFitnessDate('');
            setInitialInsuranceDate('');
            setInitialFitnessDate('');
          },
          (errorMessage) => {
            toast.error(errorMessage.data.message);
          }
        );
      }
    }
    else {
      toast.error('Document not found.');
    }
    setDocumentToRemove(null);
    setIsConfirmationOpen(false);
  }

  const handleInsuranceDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (!selectedFiles.insurance && !getInsuranceDoc) {
      setErrorMessage("Choose file to upload Insurance ");
    }
    if (value === '') {
      setErrorMessage('');
    }
    setSelectedInsuranceDate(value);
    if ((selectedFiles.insurance || getInsuranceDoc) && value) {
      if (!initialInsuranceDate) {
        setInitialInsuranceDate(event.target.value);
        uploadFile('insurance', selectedFiles?.insurance || getInsuranceDoc, value, selectedFitnessDate, 'add');
      } else {
        uploadFile('insurance', selectedFiles?.insurance || getInsuranceDoc, value, selectedFitnessDate, 'edit');
      }
    }
  };

  const handleAddOwner = (name: string, phoneNumber: string, email: any, address: any, ifsc: any, accountNumber: any, remarks: any) => {
    addOwner(name, phoneNumber, (response) => {
      toast.success(response.message);
      setIsAddOwnerModalOpen(false)
      const ownerId = response.vehicle_owner.id;
      setOwnerId(ownerId);
      if (ownerId) {
        addOwnerDetails(ownerId, accountNumber, ifsc, remarks, email, address, (response) => {
          toast.success(response.message);
        },
          (errorMessage) => {
            toast.error(errorMessage);
          });
      }
    },
      (errorMessage) => {
        toast.error(errorMessage);
      })
    setOwnerUserName(name);
    setOwnerPhoneNumber(phoneNumber);
  };

  const handleVerifyOTP = (otp: string): Promise<{ success: boolean; message?: string }> => {
    return new Promise((resolve, reject) => {
      verifyOTP(
        driverPhoneNumber,
        '91',
        otp,
        (response) => {
          if (response.data.status === 200) {
            toast.success(response.data.message);
            otpVerified = '1';
            resolve({ success: true });
            handleSave();
          } else {
            resolve({ success: false, message: response.data.message || 'OTP verification failed.' });
          }
        },
        (errorMessage) => {
          resolve({ success: false, message: errorMessage });
        }
      );
    });
  };

  const handleFitnessDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (!selectedFiles.fitnesscertificate && !getFitnessDoc) {
      setErrorMessage("Choose file to upload Fitness Certificate");
    }
    if (value === '') {
      setErrorMessage('');
    }
    setSelectedFitnessDate(value);
    if ((selectedFiles.fitnesscertificate || getFitnessDoc) && value) {
      if (!initialFitnessDate) {
        setInitialFitnessDate(value);
        uploadFile('fitnesscertificate', selectedFiles.fitnesscertificate, '', value, 'add');
      } else {
        uploadFile('fitnesscertificate', selectedFiles.fitnesscertificate, '', value, 'edit');
      }
    }
  };

  const handleCancelRemove = () => {
    setDocumentToRemove(null);
    setIsConfirmationOpen(false);
  };

  const validatePhoneNumber = (value: string, name: string) => {
    if (/[^0-9]/.test(value)) {
      if (name === 'owner') {
        setOwnerError('Invalid Phone Number');
      } else {
        setDriverError('Invalid Phone Number');
      }
      return;
    }
    if (value.length > 10) {
      if (name === 'owner') {
        setOwnerError('Phone number cannot exceed 10 digits.');
      } else {
        setDriverError('Phone number cannot exceed 10 digits.');
      }
      return;
    }
    if (value.length === 10) {
      if (name === 'owner') {
        setOwnerError('')
      } else {
        setDriverError('')
      }
      return;
    }
    if (/^[0-5]/.test(value)) {
      if (name === 'owner') {
        setOwnerError('Phone number must start with 6,7,8,9');
      } else {
        setDriverError('Phone number must start with 6,7,8,9');
      }
      return;
    }
    if (name === 'owner' && value === '') {
      setOwnerError('');
    } else if (name === 'driver' && value === '') {
      setDriverError('');
    }
  };

  const handleIconClick = (type: string, action: string) => {
    if (action === 'view' && (type === 'pollutioncertificate' || type === 'registrationcertificate')) {
      const document = documentList.find(doc => doc.document_name.replace(' ', '').toLowerCase() === type.toLowerCase() && doc.status === 'uploaded');
      if (document && !documentDeleted) {
        const url = document.location;
        window.open(`${global.documents_image_url}${url}`, '_blank');
      }
      else if (documentLocation) {
        const url = documentLocation;
        window.open(`${global.documents_image_url}${url}`, '_blank');
      }
      else {
        toast.error('Document not found.');
      }
    } else if (action === 'view' && ((type === 'fitnesscertificate' && (getFitnessDate || selectedFitnessDate)) || (type === 'insurance' && (getInsuranceDate || selectedInsuranceDate)))) {
      const document = documentList.find(doc => doc.document_name.replace(' ', '').toLowerCase() === type.toLowerCase() && doc.status === 'uploaded');
      if (document && !documentDeleted) {
        const url = document.location;
        window.open(`${global.documents_image_url}${url}`, '_blank');
      }
      else if (documentLocation) {
        const url = documentLocation;
        window.open(`${global.documents_image_url}${url}`, '_blank');
      }
      else {
        toast.error('Document not found.');
      }
    }
    else if (action === 'remove') {
      setDocumentToRemove(type);
      setIsConfirmationOpen(true);
      setDocumentDeleted(true);
    }
  };

  const fetchDriverDetails = (phoneNumber: string, name: string) => {
    if (phoneNumber.length < 10 && phoneNumber.length > 0) {
      if (name === 'owner') {
        setOwnerError("Phone number must be 10 digits")
      }
      else if (phoneNumber.length < 10 && phoneNumber.length > 0) {
        setDriverError("Phone number must be 10 digits")
      }
      else {
        setDriverError('');
        setOwnerError('');
      }
      return;
    }
    if (phoneNumber.length === 10) {
      if (name === 'owner') {
        getOwnerName(phoneNumber,
          (response: any) => {
            if (response.status === 200) {
              const user = response.message.vehicles_owners_list[0];
              setOwnerUserName(user.name);
              setOwnerPhoneNumber(user.phone);
              setOwnerId(user.id);
            }
          },
          (errMessage: any) => {
            if (errMessage.status === 404 || errMessage.message === "No Client Found") {
              setIsAddOwnerModalOpen(true);
              setOwnerId("");
              setOwnerUserName("");
            } else {
              setOwnerId("");
              setOwnerError("User Not found");
              setOwnerUserName("");
            }
          })
      }
      else {
        getDriverName(
          phoneNumber,
          (response: any) => {
            if (response.status === 200) {
              const user = response.message.user[0];
              setDriverUserName(user.user_name);
              setDriverPhoneNumber(user.user_phone);
              setDriverId(user.user_unique_id);
              getWarehouseUserMapping(
                user.user_unique_id,
                (response) => {
                  const userWarehouses = response.user_warehouses.map((mapping: { warehouse: any; }) => mapping.warehouse);
                  const mappingDetails = response.user_warehouses.map((mapping: { id: any; warehouse: { id: any; name: any; }; }) => ({
                    user_warehouse_id: mapping.id,
                    warehouse_id: mapping.warehouse.id,
                    warehouse_name: mapping.warehouse.name
                  }));

                  setWarehouseData(userWarehouses);
                  const initialSelected = userWarehouses.map((wh: { id: { toString: () => any; }; name: any; }) => ({
                    id: wh.id.toString(),
                    label: wh.name
                  }));

                  setSelectedWarehouse(initialSelected);
                  setWarehouseId(mappingDetails);
                },
                (errorMessage) => {
                  setSelectedWarehouse([]);
                  setWarehouseData([]);
                  if (errorMessage.status !== 404) {
                    toast.error(errorMessage);
                  }
                }
              );
            }
          },
          (errMessage: any) => {
            if (errMessage.status === 400) {
              if (errMessage.message.user.length === 0) {
                setDriverUserName('');
                setDriverError("User Not Found")

                setSelectedWarehouse([]);
                setWarehouseData([]);
              }
              else
                toast.error(errMessage.message);
            }
          }
        );
      }
    }
  };

  const isEqual = (obj1: any, obj2: any) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) return false;
    }
    return true;
  };

  const hasWarehouseChanged = () => {
    const currentWarehouseIds = selectedWarehouse.map(wh => wh.id);
    const previousWarehouseIds = warehouseData.map(wh => wh.id.toString());
    const addedWarehouses = currentWarehouseIds.filter(id =>
      !previousWarehouseIds.includes(id)
    );
    return addedWarehouses.length > 0;
  };

  const addNewWarehouseMappings = () => {
    if (selectedWarehouse.length > 0) {
      const currentWarehouseIds = warehouseData.map(wh => wh.id.toString());
      const warehousesToAdd = selectedWarehouse.filter(
        wh => !currentWarehouseIds.includes(wh.id)
      );
      if (warehousesToAdd.length === 0) {
        return;
      }

      const mappingPromises = warehousesToAdd.map(warehouse => {
        const warehouseId = parseInt(warehouse.id, 10);
        return new Promise((resolve, reject) => {
          addWarehouseUserMapping(
            driverId || vehicle?.driver_id,
            warehouseId,
            (mappingResponse) => {
              if (mappingResponse.data.status === 200) {
                toast.error(mappingResponse?.data?.message);
                resolve({ success: false, message: mappingResponse?.data?.message });
              } else if (mappingResponse.data.status === 201) {
                toast.success(mappingResponse.data.message);
                handleClose();
                resolve({ success: true, message: mappingResponse.data.message });
              }
            },
            (errorMessage) => {
              if (errorMessage.status === 409) {
                console.log(errorMessage.message);
              } else {
                toast.error(errorMessage.message);
                reject(errorMessage);
              }
            }
          );
        });
      });

      Promise.all(mappingPromises)
        .then(results => {
          console.log('New warehouse mappings completed', results);
        })
        .catch(error => {
          console.error('Error in warehouse mappings:', error);
        });
    }
  };

  const handleSave = () => {
    const changes = {
      model: formValues.model !== initialValues.model,
      reg_date: formValues.reg_date !== initialValues.reg_date,
      driver: driverPhoneNumber !== vehicle?.driver_phone,
      owner: ownerPhoneNumber !== vehicle?.owner_phone,
      fuel_type: (fuelType[0]?.id || '') !== vehicle?.fuel_type,
      warehouse: hasWarehouseChanged()
    };
    const otherFieldsChanged =
      changes.model ||
      changes.reg_date ||
      changes.owner ||
      changes.fuel_type;
    const changedFields = {
      model: changes.model ? formValues.model : '',
      reg_date: changes.reg_date ? formValues.reg_date : '',
      driver_id: changes.driver ? driverId : '',
      owner_id: changes.owner ? ownerId : '',
      fuel_type: changes.fuel_type ? fuelType[0]?.id || '' : ''
    };
    const isDriverFilled = formValues.driver || driverPhoneNumber;
    const isWarehouseFilled = selectedWarehouse.length > 0;
    if (isInactiveTab) {
      toast.error("Inactive vehicle can't be edited");
      return;
    }
    if (isDriverFilled && !isWarehouseFilled) {
      setWarehouseError('Warehouse is required');
      return;
    }

    if (!isDriverFilled && isWarehouseFilled) {
      setDriverError('Driver is required');
      return;
    }

    if (!formValues.model) {
      setModelError('This field is required.');
      return;
    }

    if (!formValues.reg_date) {
      setRegDateError('This field is required.');
      return;
    }

    if (ownerError || driverError || regDateError || modelError || errorMessage) {
      toast.error('Please fix the errors before saving.');
      return;
    }

    if (!otherFieldsChanged && changes.warehouse) {
      addNewWarehouseMappings();
      return;
    }

    if (!otherFieldsChanged && changes.driver) {
      editVehicle(
        '',
        '',
        vehicle?.number_plate || '',
        driverId,
        '',
        '',
        otpVerified,
        '',
        '',
        companiesId,
        (response) => {
          handleVehicleEditResponse(response);
          if ((changes.warehouse && isOtpVerified) || (driverId !== vehicle?.driver_id && isOtpVerified)) {
            addNewWarehouseMappings();
          }
        },
        (errorMessage) => {
          if (errorMessage.status === 400) {
            if (errorMessage.message.error === "Confirmation required") {
              setIsConfirmationModalOpen(true);
            }
            else if (errorMessage.message.error === "Re-confirmation required") {
              setSelectedAction('reconfirm');
              setIsConfirmationModalOpen(true);
            }
          }
          toast.error(errorMessage.message);
        }
      );
      return;
    }

    if ((otherFieldsChanged) && !changes.warehouse && !changes.driver) {
      editVehicle(
        changedFields.model,
        changedFields.reg_date,
        vehicle?.number_plate || '',
        driverId,
        changedFields.owner_id,
        changedFields.fuel_type,
        otpVerified,
        '',
        '',
        companiesId ,
        (response) => handleVehicleEditResponse(response),
        (errorMessage) => {
          if (errorMessage.status === 400) {
            if (errorMessage.message.error === "Confirmation required") {
              setIsConfirmationModalOpen(true);
            }
            else if (errorMessage.message.error === "Re-confirmation required") {
              setSelectedAction('reconfirm');
              setIsConfirmationModalOpen(true);
            }
          }
          toast.error(errorMessage.message);
        }
      );
      return;
    }

    if ((otherFieldsChanged) && (changes.warehouse || changes.driver)) {
      editVehicle(
        changedFields.model,
        changedFields.reg_date,
        vehicle?.number_plate || '',
        changedFields.driver_id,
        changedFields.owner_id,
        changedFields.fuel_type,
        otpVerified,
        '',
        '',
          companiesId,
        (response) => {
          handleVehicleEditResponse(response);
          if ((isOtpVerified && changes.warehouse) || (changes.driver && isOtpVerified)) {
            addNewWarehouseMappings();
          }
        },
        (errorMessage) => {
          if (errorMessage.status === 400) {
            if (errorMessage.message.error === "Confirmation required") {
              setIsConfirmationModalOpen(true);
            }
            else if (errorMessage.message.error === "Re-confirmation required") {
              setSelectedAction('reconfirm');
              setIsConfirmationModalOpen(true);
            }
          }
          toast.error(errorMessage.message);
        }
      );
    }
  };

  const handleVehicleEditResponse = (response: any) => {
    const warehouseAdded = hasWarehouseChanged();
    const normalizeId = (id: string | null | undefined): string | null => {
      if (id === null || id === undefined || id === '') {
        return null;
      }
      return id;
    };
    const hasDriverChanged = normalizeId(driverId) !== normalizeId(vehicle?.driver_id);
    if (response.status === 200) {
      if (response?.data?.status === 308) {
        toast.error(response.data.message);
      } else if (response?.data?.status === 400) {
        toast.error("Please contact your administrator");
      } else if (
        response?.data?.message === 'OTP sent.' ||
        response?.data?.message === 'Old OTP expired. New OTP generated and re-sent.' ||
        response?.data?.message === 'OTP re-sent.'
      ) {
        setIsOTPModalOpen(true);
        return;
      } else {
        toast.success(response.message.message);
        isOtpVerified = true

        if (!(warehouseAdded || hasDriverChanged)) {
          handleClose();
        }
      }
    } else {
      toast.error(response?.message || 'An error occurred');
    }
  };

  const isValidFileType = (file: File, allowedTypes: string[]) => {
    return allowedTypes.includes(file.type);
  };

  const handleConfirmationAction = (action: string) => {
    setIsConfirmationModalOpen(false);
    const driverStatus =
      action === '1' ? 1 :
        action === '2' ? 2 : 3;
    const switchReconfirm = action === '1' ? 1 : '';
    editVehicle(
      formValues.model,
      formValues.reg_date,
      vehicle?.number_plate || '',
      driverId,
      ownerId,
      fuelType[0]?.id || '',
      otpVerified,
      driverStatus,
      switchReconfirm,
      companiesId,
      (response) => {
        handleVehicleEditResponse(response);
        if (selectedWarehouse.length > 0) {
          const mappingPromises = selectedWarehouse.map(warehouse => {
            const warehouseId = parseInt(warehouse.id, 10);
            return new Promise((resolve, reject) => {
              addNewWarehouseMappings();
              resolve(true);
            });
          });

          Promise.all(mappingPromises)
            .then(results => {
              console.log('All warehouse mappings completed', results);
            })
            .catch(error => {
              console.error('Error in warehouse mappings:', error);
            });
        }
      }
      ,
      (errorMessage) => {
        toast.error(errorMessage.message);
        if (errorMessage.status === 400) {
          if (errorMessage.message.error === "Confirmation required") {
            setIsConfirmationModalOpen(true);
          }
          else if (errorMessage.message.error === "Re-confirmation required") {
            setSelectedAction('reconfirm');
            setIsConfirmationModalOpen(true);
          }
        }
      }
    );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const fileInput = event.target;
    const file = event.target.files?.[0] || null;
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    const maxFileSize = 1 * 1024 * 1024;
    if (!file) {
      toast.error('No file selected. Please choose a file to upload.');
      return;
    }
    if (!isValidFileType(file, allowedTypes)) {
      toast.error('Invalid file type. Please upload a jpeg, jpg, png, or pdf file.');
      return;
    }
    if (file.size > maxFileSize) {
      toast.error('File size exceeds 1 MB. Please upload a smaller file.');
      return;
    }
    setSelectedFiles((prevFiles) => ({
      ...prevFiles,
      [type]: file
    }));
    setIcons((prevIcons) => ({
      ...prevIcons,
      [type]: 'upload'
    }));
    if (vehicle?.id && file) {
      if (type === 'fitnesscertificate' && !selectedFitnessDate) {
        setErrorMessage('Expiry date is required for Fitness Certificate');
        setIcons((prevIcons) => ({
          ...prevIcons,
          [type]: 'view'
        }));
      } else if (type === 'insurance' && !selectedInsuranceDate) {
        setErrorMessage('Expiry date is required for Insurance Certificate');
        setIcons((prevIcons) => ({
          ...prevIcons,
          [type]: 'view'
        }));
      }
      else {
        setErrorMessage('');
        uploadFile(type, file, selectedFitnessDate, selectedInsuranceDate, 'add');
      }
    }
    fileInput.value = '';
  };

  const warehouseOptions = warehouses.map((warehouse) => ({
    id: warehouse.id.toString(),
    label: warehouse.name,
  }));

  const handleFuelTypeChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value;
    setFuelName(selectedId);
    const selectedOption = fuelTypeOptions.find(option => option.id === selectedId);
    if (selectedOption) {
      setFuelType([selectedOption]);
    } else {
      setFuelType([]);
    }
  };

  const handleWarehouseSelectionChange = (event: SelectChangeEvent<string>) => {
    const selectedIds = event.target.value as string[];
    const removedWarehouses = selectedWarehouse.filter(
      wh => !selectedIds.includes(wh.id)
    );
    const addedWarehouses = selectedIds.filter(
      id => !selectedWarehouse.some(wh => wh.id === id)
    );
    removedWarehouses.forEach(warehouse => {
      const mapping = warehouseId.find(
        wh => wh.warehouse_id.toString() === warehouse.id
      );

      if (mapping) {
        const userWarehouseId = mapping.user_warehouse_id;

        deleteUserWarehousemapping(
          userWarehouseId,
          (response) => {
            if (response.status === 200) {
              toast.success(`Warehouse ${warehouse.label} removed successfully`);
              setWarehouseData(prev =>
                prev.filter(wh => wh.id.toString() !== warehouse.id)
              );
              setSelectedWarehouse(prev =>
                prev.filter(wh => wh.id !== warehouse.id)
              );
            }
          },
          (error) => {
            toast.error(`Failed to remove warehouse ${warehouse.label}: ${error.message}`);
            setSelectedWarehouse(prev => [...prev, warehouse]);
          }
        );
      }
    });

    const newSelectedWarehouses = warehouseOptions.filter(option =>
      selectedIds.includes(option.id)
    );
    setSelectedWarehouse(newSelectedWarehouses);
    setWarehouseError('');
  };

  const handleVendorDropdownChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value;
    const selectedOption = vendorOptions.find(option => option.id === selectedId);
    if (selectedOption) {
      setSelectedVendor([selectedOption]);
    } else {
      setSelectedVendor([]);
    }
  };

  const vendorOptions = vendors.map((vendor) => ({
    id: vendor.id.toString(),
    label: vendor.name,
  }));

  const renderFileInput = (label: string, type: string) => (
    <Box sx={{ display: 'flex', alignItems: 'center', width: { xs: '100%', sm: '260px' } }}>
      <p style={{ display: 'inline-block', width: '170px', padding: '0px !important', margin: 0, fontSize: '14px' }}>{label}</p>
      <input
        accept="*"
        style={{ display: 'none' }}
        id={`${type}-file`}
        type="file"
        onChange={(e) => handleFileChange(e, type)}
        disabled={isInactiveTab}
      />
      <label htmlFor={!isInactiveTab ? `${type}-file` : undefined}>
        <Tooltip title="Upload File">
          <IconButton color="primary" component="span" sx={{ padding: 0 }} disabled={isInactiveTab}>
            {icons[type] === 'upload' && !isInactiveTab && <UploadIcon />}
          </IconButton>
        </Tooltip>
      </label>
      {icons[type] === 'view' && (
        <>
          <Tooltip title="View File">
            <IconButton
              component="span"
              sx={{ color: 'black', padding:'0' }}
              onClick={() => handleIconClick(type, 'view')}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          {!isInactiveTab && (
            <Tooltip title="Remove File">
              <IconButton sx={{ color: 'red' }} component="span" onClick={() => handleIconClick(type, 'remove')}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </Box>
  );

  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { width: '500px', height: 'auto' } }}>

      <Box
        sx={{
          marginLeft: {
            sm: '-180px',
          },
        }}
      >
        <Heading title={`Vehicle - ${formValues?.vehicle_no}`} closeIcon="true" onClose={handleClose} />
      </Box>

      <DialogContent>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px',
            '@media (max-width: 600px)': {
              flexDirection: 'column',
            },
          }}
        >
          {userRole === 'vendor_supervisor' || userRole === 'vendor_company_admin' ? (
            <>
              <Box display="flex" alignItems="center">
                <TextField
                  variant="outlined"
                  label="Vendor Name"
                  size="small"
                  type="text"
                  name="vendorName"
                  disabled
                  value={vendorName}
                  style={{ width: '183px' }}
                />
              </Box>
            </>
          ) : userRole === 'client_supervisor' || userRole === 'client_company_admin' ? (
            <>
              <TextField
                size="small"
                variant="outlined"
                type="text"
                name="clientName"
                value={clientName}
                disabled
                sx={{ width: { xs: '100%', sm: '183px' } }}
              />
            </>
          ) : (
            <p style={{ color: 'red' }}>User role is not vendor_supervisor, vendor_manager, client_supervisor, or client_manager</p>
          )}
          
          <Dropdown
            options={modelOptions}
            selectedValue={formValues.model}
            handleChange={handleModelChange}
            placeholder="Select Model"
            label="Select Model"
            width="183px"
            height="40px"
            error={!!modelError}
            helperText={modelError}
            disabled={isInactiveTab}
            searchable={true}
          />
          
          <Box>
            <TextField
              size="small"
              sx={{ width: 183 }}
              label={ownerUserName ? 'Owner Name' : 'Owner Phone Number'}
              placeholder="Owner Phone Number"
              name="owner"
              value={isOwnerFocused ? ownerPhoneNumber : ownerUserName || ownerPhoneNumber}
              onChange={handlePhoneNumberChange}
              error={!!ownerError}
              helperText={ownerError}
              onFocus={handleOwnerFocus}
              onBlur={handleOwnerBlur}
              disabled={isInactiveTab}
            />
          </Box>
          <TextField
            label={driverUserName ? 'Driver Name' : 'Driver Phone Number'}
            size="small"
            name="driver"
            placeholder="Driver Phone Number"
            value={(isDriverFocused ? driverPhoneNumber : driverUserName || driverPhoneNumber) || ''}
            onChange={handlePhoneNumberChange}
            onFocus={handleDriverFocus}
            onBlur={handleDriverBlur}
            error={!!driverError}
            helperText={driverError}
            sx={{ width: 183 }}
            disabled={isInactiveTab}
          />
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '15px',
              width: '100%',
              alignItems: 'flex-start',
            }}
          >
            <Box sx={{ width: { xs: '100%', md: '183px' } }}>
              <Dropdown
                options={fuelTypeOptions}
                selectedValue={fuelType.length > 0 ? fuelType[0].id : ''}
                handleChange={handleFuelTypeChange}
                placeholder="Select Fuel"
                label="Select Fuel Type"
                width="183px"
                height="40px"
                disabled={isInactiveTab}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flexGrow: 1,
                width: { xs: '100%', md: 'auto' },
                mt: { xs: 0, md: 0 }
              }}
            >
              <FormControl
                sx={{
                  flexGrow: 1,
                  maxWidth: { md: '183px' },
                  width: { xs: 'auto', md: '183px' }
                }}
              >
                <InputLabel
                  shrink={true}
                  sx={{
                    backgroundColor: 'background.paper',
                    px: 1,
                    zIndex: 1
                  }}
                  id="warehouse-multiple-label"
                >
                  Warehouse
                </InputLabel>
                <Select
                  labelId="warehouse-multiple-label"
                  id="warehouse-multiple"
                  multiple
                  size="small"
                  value={selectedWarehouse.map((wh) => wh.id)}
                  onChange={handleWarehouseSelectionChange}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => {
                        const warehouse = warehouseOptions.find((wh) => wh.id === value);
                        return warehouse ? (
                          <Chip
                            key={warehouse.id}
                            label={warehouse.label}
                            size="small"
                            onDelete={(e) => {
                              e.stopPropagation();
                              const mapping = warehouseId.find(
                                (wh) => wh.warehouse_id.toString() === warehouse.id
                              );
                              if (mapping) {
                                const userWarehouseId = mapping.user_warehouse_id;
                                deleteUserWarehousemapping(
                                  userWarehouseId,
                                  (response) => {
                                    if (response.status === 200) {
                                      toast.success(`Warehouse ${warehouse.label} removed successfully`);
                                      setWarehouseData((prev) =>
                                        prev.filter((wh) => wh.id.toString() !== warehouse.id)
                                      );
                                      setSelectedWarehouse((prev) =>
                                        prev.filter((wh) => wh.id !== warehouse.id)
                                      );
                                    }
                                  },
                                  (error) => {
                                    toast.error(`Failed to remove warehouse ${warehouse.label}: ${error.message}`);
                                    setSelectedWarehouse((prev) => [...prev, warehouse]);
                                  }
                                );
                              }
                            }}
                            deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
                          />
                        ) : null;
                      })}
                    </Box>
                  )}
                  error={!!warehouseError}
                  disabled={isInactiveTab}
                >
                  {warehouseOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {warehouseError && (
                  <p style={{ color: '#d32f2f', fontSize: '0.70rem', margin: '3px 0 0' }}>
                    {warehouseError}
                  </p>
                )}
              </FormControl>

              <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }} />

              <Tooltip title={vehicle?.active === 0 ? "Activate" : "Deactivate"}>
                <IconButton
                  size="small"
                  onClick={() => {
                    setIsConfirmationOpen(true);
                    setInactiveVehicle(true);
                  }}
                  sx={{
                    flexShrink: 0,
                    backgroundColor: vehicle?.active === 0 ? 'green' : '#d44a41',
                    color: 'white',
                    padding: '6px',
                    height: '34px',
                    width: '34px',
                    '&:hover': {
                      backgroundColor: vehicle?.active === 0 ? 'darkgreen' : '#b71c1c'
                    }
                  }}
                >
                  <PowerSettingsNewIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Box>
        <Box sx={{ marginTop: '20px', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: '10px' }}>
          {renderFileInput('Registration Certificate', 'registrationcertificate')}
          <DatePicker
            id="registrationDate"
            name="reg_date"
            label='Registration Date'
            value={formValues.reg_date}
            onChange={handleChange}
            maxDate={maxDate}
          />
        </Box>

        <Box sx={{ marginTop: '20px', display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '10px' }}>
          <Box sx={{ width: '300px' }}>
            {renderFileInput('Pollution Certificate', 'pollutioncertificate')}
          </Box>
        </Box>

        <Box sx={{ marginTop: '20px', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: '10px' }}>
          {renderFileInput('Fitness Certificate', 'fitnesscertificate')}
          <DatePicker
            id="fitnessExpiryDate"
            name="fitnessExpiryDate"
            value={selectedFitnessDate || getFitnessDate || ''}
            label="Expiry Date"
            onChange={handleFitnessDateChange}
          />
        </Box>

        <Box sx={{ marginTop: '20px', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: '10px' }}>
          {renderFileInput('Insurance', 'insurance')}
          <DatePicker
            id="insuranceExpiryDate"
            name="insuranceExpiryDate"
            value={selectedInsuranceDate || getInsuranceDate || ''}
            label="Expiry Date"
            onChange={handleInsuranceDateChange}
          />
        </Box>
        {errorMessage && (
          <div style={{ color: 'red', marginTop: '-10px', fontSize: '15px' }}>
            {errorMessage}
          </div>
        )}
      </DialogContent>
      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
        <Button className="custom-button" onClick={handleSave}>
          Save
        </Button>
        <Button className="custom-cancel-button" onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
      <ConfirmationPopup
        open={isConfirmationOpen}
        onClose={handleCancelRemove}
        onConfirm={handleConfirmRemove}
        title="Confirm Action"
        message={
          inactiveVehicle
            ? (vehicle?.active === 0
              ? <>Are you sure you want to <strong>activate</strong> the vehicle?</>
              : <>Are you sure you want to <strong>deactivate</strong> the vehicle?</>)
            : "Are you sure you want to remove this file?"
        }
      />
      <AddOwnerModal
        isOpen={isAddOwnerModalOpen}
        handleClose={() => setIsAddOwnerModalOpen(false)}
        phoneNumber={ownerPhoneNumber}
        onAddOwner={handleAddOwner}
      />
      <OTPVerificationModal
        isOpen={isOTPModalOpen}
        handleClose={() => setIsOTPModalOpen(false)}
        phoneNumber={driverPhoneNumber}
        handleVerifyOTP={handleVerifyOTP}
      />
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
        onConfirm={handleConfirmationAction}
      />
      <AddNewModelModal
        open={isAddNewModelModalOpen}
        title="Add New Vehicle Model"
        value={newModelValue}
        onChange={setNewModelValue}
        onClose={() => {
          setIsAddNewModelModalOpen(false);
          setNewModelValue("");
        }}
        onSubmit={handleAddNewModelSubmit}
      />
    </Dialog>
  );
};
export default EditVehicleModal;